
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Form, Row, Col, Button } from "react-bootstrap"
import Select from "react-select"
import { useTranslation } from "react-i18next"
import { getForSelect as getAnimalsForSelect } from '../../../actions/other/animalsActions'
import { getForSelect as getLotsForSelect } from '../../../actions/other/lotsActions'
import { getForSelect as getZonesForSelect } from '../../../actions/other/zonesActions'

export default function EventFormMovement({ type, state, handleInputChange, submit, isRegistering, isAddingOrEditing }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const { animalsForSelect } = useSelector(state => state.animals)
	const { lotsForSelect } = useSelector(state => state.lots)
	const { zonesForSelect } = useSelector(state => state.zones)

	useEffect(() => {
		dispatch(getAnimalsForSelect())
		dispatch(getLotsForSelect())
		dispatch(getZonesForSelect())
	}, [dispatch])

	const animals = animalsForSelect?.map(animal => ({ value: animal._id, label: animal.identifier }))
	const lots = lotsForSelect?.map(lot => ({ value: lot._id, label: lot.identifier }))
	const zones = zonesForSelect?.map(zone => ({ value: zone._id, label: zone.name }))

	return (
		<Form onSubmit={submit} className="formulario">
			<h1 className="mb-4">{t('menus.event_movement')}</h1>

			<Row className="my-2">
				<Col md={6}>
					<Form.Group>
						<Form.Label>{t('admin.event.movementType')}</Form.Label>
						<Select
							options={[
								{ value: 'animals', label: t('admin.animal.animals') },
								{ value: 'lots', label: t('admin.animal.lots') }
							]}
							value={state.movementType ? { value: state.movementType, label: t(`admin.animal.${state.movementType}`) } : null}
							onChange={opt => {
								handleInputChange({ target: { name: 'movementType', value: opt.value } })
								handleInputChange({ target: { name: 'animals', value: [] } })
								handleInputChange({ target: { name: 'lots', value: [] } })
								handleInputChange({ target: { name: 'zoneTo', value: null } })
								handleInputChange({ target: { name: 'lotTo', value: null } })
							}}
							isClearable
						/>
					</Form.Group>
				</Col>
			</Row>

			{state.movementType === 'animals' && (
				<Row className="my-2">
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.animal.animals')}</Form.Label>
							<Select
								isMulti
								options={animals}
								value={animals.filter(a => state.animals?.includes(a.value))}
								onChange={opts => handleInputChange({ target: { name: 'animals', value: opts ? opts.map(o => o.value) : [] } })}
								isClearable
							/>
						</Form.Group>
					</Col>
					<Col md={3}>
						<Form.Group>
							<Form.Label>{t('admin.event.to')}</Form.Label>
							<Select
								options={lots}
								value={lots.find(l => l.value === state.lotTo) || null}
								onChange={opt => handleInputChange({ target: { name: 'lotTo', value: opt?.value || '' } })}
							/>
						</Form.Group>
					</Col>
				</Row>
			)}

			{state.movementType === 'lots' && (
				<Row className="my-2">
					<Col md={6}>
						<Form.Group>
							<Form.Label>{t('admin.animal.lots')}</Form.Label>
							<Select
								isMulti
								options={lots}
								value={lots.filter(l => state.lots?.includes(l.value))}
								onChange={opts => handleInputChange({ target: { name: 'lots', value: opts ? opts.map(o => o.value) : [] } })}
								isClearable
							/>
						</Form.Group>
					</Col>
					<Col md={3}>
						<Form.Group>
							<Form.Label>{t('admin.event.to')}</Form.Label>
							<Select
								options={zones}
								value={zones.find(z => z.value === state.zoneTo) || null}
								onChange={opt => handleInputChange({ target: { name: 'zoneTo', value: opt?.value || '' } })}
							/>
						</Form.Group>
					</Col>
				</Row>
			)}

			<Row className="mt-4">
				<Col>
					<Button type="submit" className="w-100" variant="primary">
						{isRegistering
							? <span className="spinner-border spinner-border-sm" />
							: isAddingOrEditing === 'editing'
								? t('admin.animal.edit')
								: t('admin.animal.register')
						}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}
